import React from "react";
import {Vector2d} from "konva/types/types";
import {scalePointLinesDefaultStyle} from "../../constants";
import {Circle, Group} from "react-konva";
import {KonvaEventObject} from "konva/types/Node";

interface ScalePointProps {
	center: Vector2d,
	index: number,
	draggable?: boolean,
	onDragStart?: (evt: KonvaEventObject<DragEvent>, index: number) => void,
	onDragMove?: (evt: KonvaEventObject<DragEvent>, index: number) => void,
	onDragEnd?: (evt: KonvaEventObject<DragEvent>, index: number) => void,
	onMouseEnter?: (evt: KonvaEventObject<MouseEvent>) => void,
	onMouseLeave?: (evt: KonvaEventObject<MouseEvent>) => void,
}

const ScalePoint: React.FC<ScalePointProps> = ({
	center,
	index,
	draggable = false,
	onDragStart,
	onDragMove,
	onDragEnd,
	onMouseEnter,
	onMouseLeave,
}) => {
	return (
		<Group
			x={center.x}
			y={center.y}
			draggable={draggable}
			onDragStart={(evt) => onDragStart?.(evt, index)}
			onDragMove={(evt) => onDragMove?.(evt, index)}
			onDragEnd={(evt) => onDragEnd?.(evt, index)}
			onMouseEnter={onMouseEnter}
			onMouseLeave={onMouseLeave}
		>
			<Circle
				x={0}
				y={0}
				{...scalePointLinesDefaultStyle}
				radius={scalePointLinesDefaultStyle.radius!}
			/>
		</Group>
	);
}

export default ScalePoint
